import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export type GetDepartmentsResponse = {
  department_categories: string[];
  departments: Departments;
};

export type Departments = {
  [key: string]: string[];
};

export type DnextRole =
  | 'doctor'
  | 'pharmacist'
  | 'nurse'
  | 'dietitian'
  | 'medical_assistant'
  | 'medical_technologist'
  | 'radiological_technologist'
  | 'physical_therapist'
  | 'midwife'
  | 'others';

@Injectable({
  providedIn: 'root',
})
export class DoctorsNextService {
  constructor(private http: HttpClient) {}

  private getBaseUrl(clientId: string) {
    const app = environment.apps[clientId];
    if ('dnextConfig' in app === false) throw new Error();
    const baseUrl = app.dnextConfig?.apiBaseUrl;
    if (!baseUrl) throw new Error();
    return baseUrl;
  }

  /**
   * 診療科・専門を取得する
   * @link https://admin-stg.doctors-next.com/swagger/#/default/get_apiv2_departments_opened
   */
  getSpecialties(clientId: string, role: DnextRole) {
    const baseUrl = this.getBaseUrl(clientId);
    return this.http.get<GetDepartmentsResponse>(
      `${baseUrl}/apiv2/departments/opened?role=${role}`
    );
  }
}
